import merge from 'lodash/merge';
import pick from 'lodash/pick';
import { INSTITUTION_STATUS as tcStatus } from 'shared/constants';

const baseModel = {
  id: undefined,
  name: '',
  address1: '',
  address2: '',
  address3: '',
  city: '',
  stateCode: '',
  postalCode: '',
  establishDate: '',
  country: 'US',
  privateFlag: true,
  tcType: {
    type: '',
  },
};

const dtoModel = {
  ...baseModel,
  testCenterCycles: [],
};

export class TestCenter {
  constructor(data) {
    merge(this, baseModel, pick(data, Object.keys(baseModel)));
  }
}

export class TestCenterDTO {
  constructor(data) {
    merge(this, dtoModel, pick(data, Object.keys(dtoModel)));
  }

  get isActive() {
    return !!this.testCenterCycles.find(cycle => cycle.status === tcStatus.active);
  }

  get isInactive() {
    return !!this.testCenterCycles.find(cycle => cycle.status === tcStatus.inactive);
  }

  get isRenewalActive() {
    return !!this.testCenterCycles.find(cycle =>
      cycle.status === tcStatus.renewalActive || cycle.status === tcStatus.renewalReview);
  }

  get isInReview() {
    return !!this.testCenterCycles.find(cycle => cycle.status === tcStatus.inReview);
  }

  get isRestricted() {
    return !!this.testCenterCycles.find(cycle => cycle.status === tcStatus.restrict);
  }

  get isEstablishActive() {
    return !!this.testCenterCycles.find(cycle =>
      cycle.status === tcStatus.establish || cycle.status === tcStatus.establishReview);
  }
}

